import useConfigurableFields from "../../../hooks/configurable-fields";
import useEnabledCustomFieldIds from "../../../hooks/capture/useEnabledCustomFieldIds";

export default function useEnabledConfigurableFields(display, { assetCustomFields } = {}) {
  // When asset custom fields are provided (read-only modal), extract templates from them
  // instead of making a separate CustomFieldTemplates query
  const skipQuery = Array.isArray(assetCustomFields);
  const { customFields: queriedFields = [] } = useConfigurableFields({ skip: skipQuery });
  const customFields = skipQuery
    ? assetCustomFields.map(cf => cf.customFieldTemplate).filter(Boolean)
    : queriedFields;
  const enabledCustomFields = useEnabledCustomFieldIds(customFields, display);

  return enabledCustomFields.map(field => ({
    id: `customField${field.id}`,
    type: "configurable",
    params: { field },
    section: "configurable",
  }));
}
